import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "./pages/HomePage";
import AsoPage from "./pages/AsoPage";
import AppDevelopmentPage from "./pages/AppDevelopmentPage";
import UserAcquisitionPage from "./pages/UserAcquisitionPage";
import AppRetentionPage from "./pages/AppRetentionPage";
import RatingsReviewsPage from "./pages/RatingsReviewsPage";
import GeoAiCitationPage from "./pages/GeoAiCitationPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import BlogPage from "./pages/BlogPage";
import AboutPage from "./pages/AboutPage";
import PartnersPage from "./pages/PartnersPage";
import CareersPage from "./pages/CareersPage";
import ContactPage from "./pages/ContactPage";
import ResourcesPage from "./pages/ResourcesPage";
import PricingPage from "./pages/PricingPage";
import MarketHomePage from "./pages/MarketHomePage";
import FreeAsoAuditPage from "./pages/FreeAsoAuditPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import CaseStudyDetailPage from "./pages/CaseStudyDetailPage";
import AppCategoryPage from "./pages/AppCategoryPage";
import AllCategoriesPage from "./pages/AllCategoriesPage";
import AllMarketsPage from "./pages/AllMarketsPage";
import IndustryPage from "./pages/IndustryPage";
import SeoAuditToolPage from "./pages/SeoAuditToolPage";
import ServicePage from "./pages/ServicePage";
import LegalPage from "./pages/LegalPage";
import NotFoundPage from "./pages/NotFoundPage";
import AiAutomationPage from "./pages/AiAutomationPage";
import AiAutomationHubPage from "./pages/AiAutomationHubPage";
import { AI_AUTOMATION_SLUGS } from "./data/aiAutomationData";
import UsLocationsIndexPage from "./pages/UsLocationsIndexPage";
import UsLocationHubPage from "./pages/UsLocationHubPage";
import UsLocationKeywordPage from "./pages/UsLocationKeywordPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/aso" element={<AsoPage />} />
        <Route path="/aso/:categorySlug" element={<AppCategoryPage />} />
        <Route path="/app-categories" element={<AllCategoriesPage />} />
        <Route path="/markets" element={<AllMarketsPage />} />
        <Route path="/app-development" element={<AppDevelopmentPage />} />
        <Route path="/user-acquisition" element={<UserAcquisitionPage />} />
        <Route path="/app-retention" element={<AppRetentionPage />} />
        <Route path="/ratings-reviews" element={<RatingsReviewsPage />} />
        <Route path="/geo-ai-citation" element={<GeoAiCitationPage />} />
        <Route path="/case-studies" element={<CaseStudiesPage />} />
        <Route path="/case-studies/:slug" element={<CaseStudyDetailPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/free-aso-audit" element={<FreeAsoAuditPage />} />
        {/* Free SEO Audit Tool — user-submitted audits */}
        <Route path="/seo-audit" element={<SeoAuditToolPage />} />
        <Route path="/free-seo-audit" element={<SeoAuditToolPage />} />
        <Route path="/website-audit" element={<SeoAuditToolPage />} />
        {/* Legal pages */}
        <Route path="/privacy" element={<LegalPage />} />
        <Route path="/terms" element={<LegalPage />} />
        <Route path="/cookies" element={<LegalPage />} />
        {/* Lumotis service routes */}
        <Route path="/ai-search-optimization" element={<GeoAiCitationPage />} />
        <Route path="/seo" element={<AsoPage />} />
        <Route path="/local-seo" element={<AsoPage />} />
        <Route path="/paid-advertising" element={<UserAcquisitionPage />} />
        <Route path="/social-media" element={<UserAcquisitionPage />} />
        <Route path="/email-sms" element={<AppRetentionPage />} />
        {/* Tier 1 expansion services — data-driven pages */}
        <Route path="/cro" element={<ServicePage />} />
        <Route path="/conversion-rate-optimization" element={<ServicePage />} />
        <Route path="/content-marketing" element={<ServicePage />} />
        <Route path="/web-design" element={<ServicePage />} />
        <Route path="/website-design" element={<ServicePage />} />
        <Route path="/marketing-automation" element={<ServicePage />} />
        <Route path="/link-building" element={<ServicePage />} />
        {/* AI Automation hub + one page per industry (e.g. /real-estate-ai-automation) */}
        <Route path="/ai-automation" element={<AiAutomationHubPage />} />
        {AI_AUTOMATION_SLUGS.map((s) => (
          <Route key={s} path={`/${s}`} element={<AiAutomationPage />} />
        ))}
        {/* Lumotis industry pages — explicit static routes so they don't conflict with /:market */}
        <Route path="/shopify-ecommerce" element={<IndustryPage />} />
        <Route path="/real-estate-marketing" element={<IndustryPage />} />
        <Route path="/salon-spa-marketing" element={<IndustryPage />} />
        <Route path="/healthcare-marketing" element={<IndustryPage />} />
        <Route path="/restaurant-marketing" element={<IndustryPage />} />
        {/* ─── LOCALISED SERVICE & INDUSTRY ROUTES (per-market) ───
            10 markets × ~16 pages — must appear BEFORE /:market */}
        {/* Tier-1 services */}
        <Route path="/:market/cro" element={<ServicePage />} />
        <Route path="/:market/conversion-rate-optimization" element={<ServicePage />} />
        <Route path="/:market/content-marketing" element={<ServicePage />} />
        <Route path="/:market/web-design" element={<ServicePage />} />
        <Route path="/:market/website-design" element={<ServicePage />} />
        <Route path="/:market/marketing-automation" element={<ServicePage />} />
        <Route path="/:market/link-building" element={<ServicePage />} />
        {/* Legacy service aliases */}
        <Route path="/:market/ai-search-optimization" element={<GeoAiCitationPage />} />
        <Route path="/:market/seo" element={<AsoPage />} />
        <Route path="/:market/local-seo" element={<AsoPage />} />
        <Route path="/:market/paid-advertising" element={<UserAcquisitionPage />} />
        <Route path="/:market/social-media" element={<UserAcquisitionPage />} />
        <Route path="/:market/email-sms" element={<AppRetentionPage />} />
        {/* Industry pages */}
        <Route path="/:market/shopify-ecommerce" element={<IndustryPage />} />
        <Route path="/:market/real-estate-marketing" element={<IndustryPage />} />
        <Route path="/:market/salon-spa-marketing" element={<IndustryPage />} />
        <Route path="/:market/healthcare-marketing" element={<IndustryPage />} />
        <Route path="/:market/restaurant-marketing" element={<IndustryPage />} />
        {/* ─── USA programmatic location pages ───
            Placed AFTER the explicit /:market/<service> routes so /us/cro etc. still
            resolve to their service pages (React Router breaks score ties by order). */}
        <Route path="/us/locations" element={<UsLocationsIndexPage />} />
        <Route path="/us/:location/:keyword" element={<UsLocationKeywordPage />} />
        <Route path="/us/:location" element={<UsLocationHubPage />} />
        {/* Localized country homepages — MUST remain last; MarketHomePage redirects invalid slugs to / */}
        <Route path="/:market" element={<MarketHomePage />} />
        {/* Catch-all 404 — must be the final route */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Toaster position="bottom-right" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
